import $axios from "@/api";
function get(url, state, payload = null) {
    state.filter.requested = true
    return new Promise((resolve) => {
        $axios.get(url, {
            params: payload === null ? state.filter : payload
        }).then((response) => {
            if (state.filter.testing) {
                console.log(response.data)
            }
            state.filter.requested = false
            state.response.data = response.data.data
            state.response.meta = response.data.meta
            resolve(response.data)
        })
    })
}
function post(url, state, payload = null, dispatch, callback = '') {
    return new Promise((resolve) => {
        $axios.post(url, payload === null ? state.form : payload
        ).then((response) => {
            dispatch(callback).then(() => {
                resolve(response.data)
            })
        })
    })
}
function destroy(url, payload = null, dispatch, callback = '') {
    return new Promise((resolve) => {
        $axios.delete(url + '/' + payload)
            .then((response) => {
                dispatch(callback).then(() => {
                    resolve(response.data)
                })
            })
    })
}
export default { get, post, destroy }